import React from "react";
import PropTypes from "prop-types";
import {Redirect, Route} from "react-router-dom";

import Layout from "../../components/Layout";

const SimpleRoute = ({
  component: Component,
  isHome = false,
  isNotes = false,
  LayoutProps,
  scrollTop=true,
  ...props
}) => {

  scrollTop && window.scrollTo(0, 0);
  
  /* const dateTime = (new Date()).getTime(); */
  if(props.path === "login" /* && props.expireSession && props.expireSession<dateTime */){
    return <Redirect
      to={{
        pathname: "/panel"
      }}
    />
  }
  return <Route {...props}>
    <Layout isHome={isHome} isNotes={isNotes} {...LayoutProps}>
      <Component {...props} />
    </Layout>
  </Route>
};

SimpleRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  exact: PropTypes.bool,
  isHome: PropTypes.bool,
  isNotes: PropTypes.bool,
  LayoutProps: PropTypes.object,
  scrollTop: PropTypes.bool
};

export default SimpleRoute;
